const RANKINGS = [
  { rank: 1, title: '香蕉视频 · 热播电视剧专区', desc: '最新上线的热门剧集每日更新，高清画质全集连播', tag: '剧集', change: 'up' },
  { rank: 2, title: '蜜桃视频 · 电影大片合集', desc: '国内外院线大片与经典电影一网打尽', tag: '电影', change: 'up' },
  { rank: 3, title: '西瓜视频 · 综艺娱乐频道', desc: '热门综艺节目实时更新，欢乐不间断', tag: '综艺', change: 'up' },
  { rank: 4, title: '樱花视频 · 动漫番剧专区', desc: '最新番剧与经典动漫作品高清收录', tag: '动漫', change: 'stable' },
  { rank: 5, title: '糖豆视频 · 纪录片精选', desc: '精品纪录片、人文纪实内容深度推荐', tag: '纪录', change: 'up' },
];

function ChangeIcon({ type }: { type: string }) {
  if (type === 'up') {
    return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
  }
  if (type === 'down') {
    return <i className="ri-arrow-down-line text-primary-500 text-sm"></i>;
  }
  return <i className="ri-subtract-line text-foreground-300 text-sm"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          各大平台热门内容实时排行
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {RANKINGS.map((item, idx) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-300/60 transition-all duration-200"
            >
              <div className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-bold text-sm md:text-base ${
                idx === 0 ? 'bg-primary-500 text-background-50' :
                idx === 1 ? 'bg-secondary-500 text-background-50' :
                idx === 2 ? 'bg-accent-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 truncate whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
                  {item.desc}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="px-2.5 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <ChangeIcon type={item.change} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}